import { lazy } from 'react';

import {
  AdminPolicy,
  BlastsViewPolicy,
  ContactPersonPolicy,
} from '../policies';

const Dashboard = lazy(() => import('./dashboard'));
const Documents = lazy(() => import('./documents'));
const MeasuringData = lazy(() => import('./measuring-data'));
const MeasuringPoints = lazy(() => import('./measuring-points'));
const MeasuringCards = lazy(() => import('./measuring-cards'));
const Users = lazy(() => import('./users'));
const Blasts = lazy(() => import('./blasts'));
const Noise = lazy(() => import('./noise'));
const Notifications = lazy(() => import('./notifications'));
const Analytics = lazy(() => import('./analytics'));
const DocumentLibrary = lazy(() => import('./document-library'));

const routes = [
  {
    path: '/project/:projectKey',
    nameInPath: '',
    component: Dashboard,
    name: 'Översikt',
    icon: 'dashboard',
    exact: true,
    allowedRoles: AdminPolicy,
  },
  {
    path: '/project/:projectKey/users',
    nameInPath: 'users',
    component: Users,
    name: 'Projektanvändare',
    icon: 'people',
    allowedRoles: AdminPolicy,
  },
  {
    path: '/project/:projectKey/measuringdata',
    nameInPath: 'measuringdata',
    component: MeasuringData,
    name: 'Mätdata',
    icon: 'trending_up',
    allowedRoles: ContactPersonPolicy,
  },
  {
    path: '/project/:projectKey/albums/:albumId',
    nameInPath: 'documents',
    component: DocumentLibrary,
    name: 'Dokument',
    icon: 'attach_file',
    allowedRoles: AdminPolicy,
    storageMode: 'MODERN',
    hidden: true,
  },
  {
    path: '/project/:projectKey/documents/:path*',
    nameInPath: 'documents',
    component: DocumentLibrary,
    name: 'Dokument',
    icon: 'attach_file',
    allowedRoles: AdminPolicy,
    storageMode: 'MODERN',
  },
  {
    path: '/project/:projectKey/documents',
    nameInPath: 'documents',
    component: Documents,
    name: 'Dokument',
    icon: 'attach_file',
    allowedRoles: AdminPolicy,
    storageMode: 'LEGACY',
  },
  {
    path: '/project/:projectKey/measuringpoints',
    nameInPath: 'measuringpoints',
    component: MeasuringPoints,
    name: 'Mätpunkter',
    icon: 'location_on',
    allowedRoles: AdminPolicy,
  },
  {
    path: '/project/:projectKey/measuringcard/:measuringCardId',
    nameInPath: 'measuringcard',
    component: MeasuringCards,
    allowedRoles: AdminPolicy,
    hidden: true,
  },
  {
    path: '/project/:projectKey/measuringcards',
    nameInPath: 'measuringcards',
    component: MeasuringCards,
    name: 'Mätarkort',
    icon: 'assignment',
    allowedRoles: AdminPolicy,
  },
  {
    path: '/project/:projectKey/blasts',
    nameInPath: 'blasts',
    component: Blasts,
    name: 'Salvor',
    icon: 'offline_bolt',
    allowedRoles: BlastsViewPolicy,
  },
  {
    path: '/project/:projectKey/noise',
    nameInPath: 'noise',
    component: Noise,
    name: 'Buller/Stomljud',
    icon: 'surround_sound',
    allowedRoles: ContactPersonPolicy,
  },
  {
    path: '/project/:projectKey/notifications',
    nameInPath: 'notifications',
    component: Notifications,
    name: 'Notifikationer',
    icon: 'sms',
    allowedRoles: AdminPolicy,
  },
  !!process.env.REACT_APP_ENABLE_TELLUS_ANALYTICS && {
    path: '/project/:projectKey/analytics',
    nameInPath: 'analytics',
    component: Analytics,
    name: 'DTWeb',
    icon: 'analytics',
    allowedRoles: AdminPolicy,
  },
].filter((x) => !!x);

export default routes;
